import { format, subDays } from 'date-fns';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const DEFAULT_KEY = 'selection';

const DateRangePickerDropdown = ({
	onRangeChosen,
	startDate = subDays(new Date(), 30),
	endDate = new Date(),
	minDate = subDays(new Date(), 90),
	maxDate = new Date(),
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const [pickerState, setPickerState] = useState([
		{ startDate, endDate, key: DEFAULT_KEY },
	]);

	const handleChange = (item) => {
		if (item[DEFAULT_KEY]) {
			setPickerState([item[DEFAULT_KEY]]);
		}
	};

	const handleToggle = (event) => {
		event.preventDefault();
		setIsOpen(!isOpen);
	};

	const handleCancel = () => {
		setIsOpen(false);
	};

	const handleApply = () => {
		onRangeChosen(pickerState[0]);
		setIsOpen(false);
	};

	return (
		<details className="dropdown dropdown-bottom dropdown-end" open={isOpen}>
			<summary className="btn btn-primary btn-sm" onClick={handleToggle}>
				{`${format(pickerState[0].startDate, 'MM/dd/yyyy')} - ${format(pickerState[0].endDate, 'MM/dd/yyyy')}`}
			</summary>
			<div className="z-10 mt-2 bg-white border shadow-lg shadow-neutral-800 dropdown-content">
				<DateRangePicker
					onChange={handleChange}
					showSelectionPreview
					moveRangeOnFirstSelection={false}
					months={2}
					direction="horizontal"
					inputRanges={[]}
					minDate={minDate}
					maxDate={maxDate}
					ranges={pickerState}
				/>
				<div className="flex flex-row-reverse gap-2 p-2">
					<button className="btn btn-sm btn-primary" onClick={handleApply}>
						Apply
					</button>
					<button className="btn btn-sm btn-outline" onClick={handleCancel}>
						Cancel
					</button>
				</div>
			</div>
		</details>
	);
};

DateRangePickerDropdown.propTypes = {
	onRangeChosen: PropTypes.func,
	startDate: PropTypes.object,
	endDate: PropTypes.object,
	minDate: PropTypes.object,
	maxDate: PropTypes.object,
};

export default DateRangePickerDropdown;
